const autocompleteFormService = {
  places: 'Local',
  equipments: 'Equipment (first 50 matches)',
  serviceType: 'Service Type',
  latitude: 'Latitude',
  longitude: 'Longitude',
  noAuthorization: 'No Authorization',
};

export default autocompleteFormService;
